import { render } from "./LightboxProductsMostPurchasedSkeleton.vue?vue&type=template&id=8ed721e6&scoped=true"
import script from "./LightboxProductsMostPurchasedSkeleton.vue?vue&type=script&lang=js"
export * from "./LightboxProductsMostPurchasedSkeleton.vue?vue&type=script&lang=js"

import "./LightboxProductsMostPurchasedSkeleton.vue?vue&type=style&index=0&id=8ed721e6&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ed721e6"]])

export default __exports__